/**
 * Add stylesheet to react code.
 * Used for changing style outside of the component context
 * The style removed after unmount.
 */

import { useEffect } from "react"

export function useStyleSheet(css){
  useEffect(()=>{
    var style=document.createElement('style')
    document.body.appendChild(style)
    style.innerHTML=css
    return ()=>{
      document.body.removeChild(style)
    }
  },[])
}

/**
 * Every component with the classname "hide-on-print"
 * will be hidden during print
 */
export function useHideOnPrintStyleSheet() {
  useStyleSheet(`
      @media print {
        .hide-on-print {
          display:none;
        }
      }
  `)
}